import styled from "styled-components"
import { themeModules } from "../../../../theme/theme.js"
import InputWithFlag from "../../../inputWithFlag.jsx";
import Button from '@mui/material/Button';
import api from '../../../../axios.js'
import {useState,useEffect} from "react"
import { useSelector,useDispatch } from "react-redux"
import {getFechaLocal} from "../../../../services/utilities.js"
import { newReventa,estadoReventa } from "../../../../redux/actions/reventaActions.js"
import Card from '../../../juegos/card.jsx'


const Container=styled.div`
	height:100%;
	width:100%;
	display:flex;
	justify-content:center;
	align-items:center;
	z-index:1
`;

const Backdrop=styled.div`
	position:absolute;
	background-color:black;
	height:100%;
	width:100%;
	opacity:0.8;
	z-index:5
`;

const Content=styled.div`
	z-index:6;
	background-color:${themeModules.panel};
	width:85%;
	height:90%;
	border-radius:8px;
	display:flex;
	flex-direction:column
`;

let ContentInput=styled.div`
	display:flex;
	width:50%;
	justify-content:space-between;
	align-items:center;
	margin:5px;
	margin-left:35px
`;

let Separations=styled.div`
	display:flex;
	width:100%;
	height:85%;
	justify-content:space-evenly
`;

let ConatainerInputsPrices=styled.div`
	min-width:600px;
`;
	
let ContainerCard=styled.div`
	height:100%;
	width:50%;
	display:flex;
	justify-content:center;
	align-items:center;	
`;

let ContainerFondoCard=styled.div`
	height:60%;
	width:50%

`

export default function ReventaConfigPrices(props){
	let {reventa,setReventaSave,setOpen,setLoad,consola,poster}=props;
	let [readyToSave,setReadyToSave]=useState(false);
	let [saving,setSaving]=useState(false);
	let newReventaRedux=useSelector(state=>state.reventa.newReventa);
	let dispatch=useDispatch();

	useEffect(()=>{
		const tieneValorInvalido = Object.values(newReventaRedux).some(valor => Number(valor) < 1);
		setReadyToSave(!tieneValorInvalido);
	},[newReventaRedux])
	
	let saveNewReventaPrices=async()=>{
		if(window.confirm("desea grabar estos precios")){
			try{
				dispatch(estadoReventa(2))
				setSaving(true);
				let response = await api.patch("/reventa",{id:reventa.id,precios_configurados:true,publicar_reventa:true,fecha_publicar: getFechaLocal(),...newReventaRedux});
				setLoad(false);
				setOpen(false);
				setReventaSave("");
				alert("Precios guardados,juego publicado")
				setSaving(false);
				dispatch(newReventa({
					precio_peru:"",
					precio_resto:"",
					precio_argentina:"",
					precio_bolivia:"",
					precio_chile:"",
					precio_colombia:"",
					precio_mexico:"",
					precio_uruguay:""	
				}))
				dispatch(estadoReventa(0))
			}catch(err){console.log(err)}
		}	
		
	}

	return(
		<Container>
			<Backdrop/>
			<Content>
				<ContentInput style={{width:"89%",padding:"5px"}}>
					<div>establecer precios de reventa</div>
					<Button variant="contained" disabled={readyToSave==true&saving==false?false:true} onClick={saveNewReventaPrices}>Grabar precios</Button>
				</ContentInput>
				<Separations>
					<ConatainerInputsPrices>
						<ContentInput>Peru<InputWithFlag codFlag="pe" pais="peru" label="soles" value={newReventa.precio_peru}/></ContentInput>
						<ContentInput>Bolivia<InputWithFlag codFlag="bo" pais="bolivia" label="bolivianos" value={newReventa.precio_bolivia}/></ContentInput>
						<ContentInput>Argentina<InputWithFlag codFlag="ar" pais="argentina" label="pesos" value={newReventa.precio_argentina}/></ContentInput>
						<ContentInput>Mexico<InputWithFlag codFlag="mx" pais="mexico" label="pesos" value={newReventa.precio_mexico}/></ContentInput>
						<ContentInput>Colombia<InputWithFlag codFlag="co" pais="colombia" label="pesos" value={newReventa.precio_colombia}/></ContentInput>
						<ContentInput>Chile<InputWithFlag codFlag="cl" pais="chile" label="pesos" value={newReventa.precio_chile}/></ContentInput>
						<ContentInput>Uruguay<InputWithFlag codFlag="uy" pais="uruguay" label="pesos" value={newReventa.precio_uruguay}/></ContentInput>
						<ContentInput>DOLAR<InputWithFlag codFlag="us" pais="resto" label="dolares" value={newReventa.precio_resto}/></ContentInput>
					</ConatainerInputsPrices>
				{poster&&consola?
					<ContainerCard>
						<ContainerFondoCard>
							<Card poster={poster} consola={consola}/>
						</ContainerFondoCard>
					</ContainerCard>:null
					}
				</Separations>	
			</Content>
			 
			
		</Container>


	)

}